import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from '../sections/HeroSection';
import { EmotionalOpening } from '../sections/EmotionalOpening';
import { ProblemSolution } from '../sections/ProblemSolution';
import { WhatsInside } from '../sections/WhatsInside';
import { Bonuses } from '../sections/Bonuses';
import { EmotionalClosing } from '../sections/EmotionalClosing';
import { Testimonials } from '../sections/Testimonials';
import { FAQ } from '../sections/FAQ';
import { FinalCTA } from '../sections/FinalCTA';
export function ProductPage() {
  return <div className="min-h-screen flex flex-col" data-id="element-82">
      <Header data-id="element-83" />
      <main className="flex-grow" data-id="element-84">
        <HeroSection data-id="element-85" />
        <EmotionalOpening data-id="element-86" />
        <ProblemSolution data-id="element-87" />
        <WhatsInside data-id="element-88" />
        <Bonuses data-id="element-89" />
        <EmotionalClosing data-id="element-90" />
        <Testimonials data-id="element-91" />
        <FAQ data-id="element-92" />
        <FinalCTA data-id="element-93" />
      </main>
      <Footer data-id="element-94" />
    </div>;
}